import { useContext } from 'react';

import { ThemeContext } from './ThemeContext';

export const useTheme = () => {
  const context = useContext(ThemeContext);

  if (context === undefined) {
    throw new Error(
      '`useTheme` hook must be used within a `ThemeContext` component'
    );
  }

  return context;
};
